// Marketing PR-C — Drips API client.
// Mounted server-side at /api/marketing/drips-v2.

import { apiGet, apiPost, apiPatch, apiDel } from '../lib/api.js';

const BASE = '/marketing/drips-v2';

export const listDrips = (params = {}) => {
  const q = new URLSearchParams();
  if (params.enabled !== undefined) q.set('enabled', String(params.enabled));
  const qs = q.toString();
  return apiGet(`${BASE}${qs ? `?${qs}` : ''}`);
};
export const getDrip = (id) => apiGet(`${BASE}/${id}`);
export const createDrip = (body) => apiPost(BASE, body);
export const updateDrip = (id, body) => apiPatch(`${BASE}/${id}`, body);
export const deleteDrip = (id, hard = false) =>
  apiDel(`${BASE}/${id}${hard ? '?hard=true' : ''}`);
export const startDrip = (id, leadId) => apiPost(`${BASE}/${id}/start`, { leadId });
export const stopDrip = (id, leadId) => apiPost(`${BASE}/${id}/stop`, { leadId });
export const listDripEnrollments = (id, params = {}) => {
  const q = new URLSearchParams();
  if (params.page) q.set('page', String(params.page));
  if (params.limit) q.set('limit', String(params.limit));
  if (params.status) q.set('status', params.status);
  const qs = q.toString();
  return apiGet(`${BASE}/${id}/enrollments${qs ? `?${qs}` : ''}`);
};
export const listActiveDripsForLead = (leadId) => apiGet(`${BASE}/lead/${leadId}/active`);
